import { NavigationLink } from './navigation-link';

export class Navigation {
  constructor(readonly items: NavigationLink[]) {
    if (!items || !items.length) {
      throw new Error('No items have been defined.');
    }
  }
}
